export default "/build/images/back.png?998a611564ca1258744e12fab3bc7ad7";